import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const confirmSmsSteps = (statusCheck: string) => {
    return axiosPrivate.get(statusCheck);
}